import React from "react";
import { ScrollText } from "lucide-react";

const TermsAndConditions = () => {
  return (
    <>
      <style>
        {`
        @import url(https://themes.googleusercontent.com/fonts/css?kit=fpjTOVmNbO4Lz34iLyptLUXza5VhXqVC6o75Eld_V98);
      .lst-kix_list_14-1 > li:before {
        content: "o  ";
      }
      .lst-kix_list_14-3 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_1-0 {
        list-style-type: none;
      }
      .lst-kix_list_14-0 > li:before {
        content: "\\0025cf   ";
      }
      .lst-kix_list_14-4 > li:before {
        content: "\\0025aa";
      }
      .lst-kix_list_14-5 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_14-7 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_14-6 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_9-3 {
        list-style-type: none;
      }
      ul.lst-kix_list_9-4 {
        list-style-type: none;
      }
      ul.lst-kix_list_9-1 {
        list-style-type: none;
      }
      ul.lst-kix_list_9-2 {
        list-style-type: none;
      }
      ul.lst-kix_list_9-7 {
        list-style-type: none;
      }
      ul.lst-kix_list_9-8 {
        list-style-type: none;
      }
      ul.lst-kix_list_9-5 {
        list-style-type: none;
      }
      ul.lst-kix_list_9-6 {
        list-style-type: none;
      }
      ul.lst-kix_list_1-3 {
        list-style-type: none;
      }
      ul.lst-kix_list_1-4 {
        list-style-type: none;
      }
      ul.lst-kix_list_1-1 {
        list-style-type: none;
      }
      ul.lst-kix_list_1-2 {
        list-style-type: none;
      }
      ul.lst-kix_list_1-7 {
        list-style-type: none;
      }
      ul.lst-kix_list_9-0 {
        list-style-type: none;
      }
      ul.lst-kix_list_1-8 {
        list-style-type: none;
      }
      ul.lst-kix_list_1-5 {
        list-style-type: none;
      }
      .lst-kix_list_14-2 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_1-6 {
        list-style-type: none;
      }
      .lst-kix_list_14-8 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_5-0 > li:before {
        content: "\\0025cf   ";
      }
      .lst-kix_list_5-3 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_5-2 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_5-1 > li:before {
        content: "o  ";
      }
      .lst-kix_list_5-7 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_8-4 {
        list-style-type: none;
      }
      ul.lst-kix_list_8-5 {
        list-style-type: none;
      }
      .lst-kix_list_5-6 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_5-8 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_8-2 {
        list-style-type: none;
      }
      ul.lst-kix_list_8-3 {
        list-style-type: none;
      }
      ul.lst-kix_list_8-8 {
        list-style-type: none;
      }
      ul.lst-kix_list_8-6 {
        list-style-type: none;
      }
      ul.lst-kix_list_8-7 {
        list-style-type: none;
      }
      .lst-kix_list_5-4 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_5-5 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_8-0 {
        list-style-type: none;
      }
      ul.lst-kix_list_8-1 {
        list-style-type: none;
      }
      .lst-kix_list_6-1 > li:before {
        content: "o  ";
      }
      .lst-kix_list_6-3 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_6-0 > li:before {
        content: "\\0025cf   ";
      }
      .lst-kix_list_6-4 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_16-2 {
        list-style-type: none;
      }
      ul.lst-kix_list_16-1 {
        list-style-type: none;
      }
      ul.lst-kix_list_16-0 {
        list-style-type: none;
      }
      .lst-kix_list_6-2 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_16-8 {
        list-style-type: none;
      }
      ul.lst-kix_list_16-7 {
        list-style-type: none;
      }
      ul.lst-kix_list_16-6 {
        list-style-type: none;
      }
      ul.lst-kix_list_16-5 {
        list-style-type: none;
      }
      ul.lst-kix_list_16-4 {
        list-style-type: none;
      }
      .lst-kix_list_6-8 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_16-3 {
        list-style-type: none;
      }
      .lst-kix_list_6-5 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_6-7 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_6-6 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_2-7 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_7-4 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_7-6 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_2-5 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_7-2 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_3-7 {
        list-style-type: none;
      }
      ul.lst-kix_list_3-8 {
        list-style-type: none;
      }
      .lst-kix_list_10-1 > li:before {
        content: "o  ";
      }
      .lst-kix_list_13-7 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_3-1 {
        list-style-type: none;
      }
      ul.lst-kix_list_3-2 {
        list-style-type: none;
      }
      .lst-kix_list_7-8 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_3-0 {
        list-style-type: none;
      }
      ul.lst-kix_list_3-5 {
        list-style-type: none;
      }
      ul.lst-kix_list_3-6 {
        list-style-type: none;
      }
      ul.lst-kix_list_3-3 {
        list-style-type: none;
      }
      ul.lst-kix_list_3-4 {
        list-style-type: none;
      }
      .lst-kix_list_10-7 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_15-5 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_10-5 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_10-3 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_11-7 {
        list-style-type: none;
      }
      ul.lst-kix_list_11-6 {
        list-style-type: none;
      }
      .lst-kix_list_4-1 > li:before {
        content: "o  ";
      }
      ul.lst-kix_list_11-5 {
        list-style-type: none;
      }
      ul.lst-kix_list_11-4 {
        list-style-type: none;
      }
      ul.lst-kix_list_11-3 {
        list-style-type: none;
      }
      .lst-kix_list_15-7 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_11-2 {
        list-style-type: none;
      }
      ul.lst-kix_list_11-1 {
        list-style-type: none;
      }
      ul.lst-kix_list_11-0 {
        list-style-type: none;
      }
      .lst-kix_list_9-2 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_4-3 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_4-5 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_11-8 {
        list-style-type: none;
      }
      .lst-kix_list_15-1 > li:before {
        content: "o  ";
      }
      .lst-kix_list_9-0 > li:before {
        content: "\\0025cf   ";
      }
      .lst-kix_list_15-3 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_9-6 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_9-4 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_11-3 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_2-8 {
        list-style-type: none;
      }
      .lst-kix_list_12-3 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_11-5 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_12-1 > li:before {
        content: "o  ";
      }
      ul.lst-kix_list_2-2 {
        list-style-type: none;
      }
      ul.lst-kix_list_2-3 {
        list-style-type: none;
      }
      ul.lst-kix_list_2-0 {
        list-style-type: none;
      }
      ul.lst-kix_list_2-1 {
        list-style-type: none;
      }
      .lst-kix_list_9-8 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_2-6 {
        list-style-type: none;
      }
      .lst-kix_list_1-1 > li:before {
        content: "o  ";
      }
      ul.lst-kix_list_2-7 {
        list-style-type: none;
      }
      .lst-kix_list_11-7 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_2-4 {
        list-style-type: none;
      }
      ul.lst-kix_list_2-5 {
        list-style-type: none;
      }
      ul.lst-kix_list_10-0 {
        list-style-type: none;
      }
      .lst-kix_list_1-3 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_13-3 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_10-8 {
        list-style-type: none;
      }
      ul.lst-kix_list_10-7 {
        list-style-type: none;
      }
      .lst-kix_list_1-7 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_10-6 {
        list-style-type: none;
      }
      ul.lst-kix_list_10-5 {
        list-style-type: none;
      }
      ul.lst-kix_list_10-4 {
        list-style-type: none;
      }
      ul.lst-kix_list_10-3 {
        list-style-type: none;
      }
      .lst-kix_list_1-5 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_10-2 {
        list-style-type: none;
      }
      ul.lst-kix_list_10-1 {
        list-style-type: none;
      }
      .lst-kix_list_13-5 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_12-5 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_12-7 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_2-1 > li:before {
        content: "o  ";
      }
      .lst-kix_list_2-3 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_13-1 > li:before {
        content: "o  ";
      }
      .lst-kix_list_3-0 > li:before {
        content: "\\0025cf   ";
      }
      ul.lst-kix_list_5-7 {
        list-style-type: none;
      }
      ul.lst-kix_list_5-8 {
        list-style-type: none;
      }
      .lst-kix_list_3-1 > li:before {
        content: "o  ";
      }
      .lst-kix_list_3-2 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_5-5 {
        list-style-type: none;
      }
      ul.lst-kix_list_5-6 {
        list-style-type: none;
      }
      .lst-kix_list_8-1 > li:before {
        content: "o  ";
      }
      .lst-kix_list_8-2 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_3-5 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_5-0 {
        list-style-type: none;
      }
      .lst-kix_list_3-4 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_5-3 {
        list-style-type: none;
      }
      .lst-kix_list_3-3 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_5-4 {
        list-style-type: none;
      }
      ul.lst-kix_list_5-1 {
        list-style-type: none;
      }
      .lst-kix_list_8-0 > li:before {
        content: "\\0025cf   ";
      }
      ul.lst-kix_list_5-2 {
        list-style-type: none;
      }
      .lst-kix_list_8-7 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_3-8 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_8-5 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_8-6 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_8-3 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_13-5 {
        list-style-type: none;
      }
      ul.lst-kix_list_13-4 {
        list-style-type: none;
      }
      ul.lst-kix_list_13-3 {
        list-style-type: none;
      }
      .lst-kix_list_3-6 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_13-2 {
        list-style-type: none;
      }
      ul.lst-kix_list_13-1 {
        list-style-type: none;
      }
      .lst-kix_list_3-7 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_13-0 {
        list-style-type: none;
      }
      .lst-kix_list_8-4 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_11-2 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_13-8 {
        list-style-type: none;
      }
      .lst-kix_list_11-1 > li:before {
        content: "o  ";
      }
      ul.lst-kix_list_13-7 {
        list-style-type: none;
      }
      ul.lst-kix_list_13-6 {
        list-style-type: none;
      }
      .lst-kix_list_11-0 > li:before {
        content: "\\0025cf   ";
      }
      .lst-kix_list_8-8 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_16-8 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_16-7 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_16-6 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_4-8 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_4-7 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_4-8 {
        list-style-type: none;
      }
      .lst-kix_list_16-0 > li:before {
        content: "\\0025cf   ";
      }
      ul.lst-kix_list_4-6 {
        list-style-type: none;
      }
      .lst-kix_list_16-1 > li:before {
        content: "o  ";
      }
      ul.lst-kix_list_4-7 {
        list-style-type: none;
      }
      .lst-kix_list_16-2 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_4-0 {
        list-style-type: none;
      }
      .lst-kix_list_16-4 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_4-1 {
        list-style-type: none;
      }
      .lst-kix_list_16-3 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_16-5 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_4-4 {
        list-style-type: none;
      }
      ul.lst-kix_list_4-5 {
        list-style-type: none;
      }
      ul.lst-kix_list_4-2 {
        list-style-type: none;
      }
      ul.lst-kix_list_4-3 {
        list-style-type: none;
      }
      ul.lst-kix_list_12-6 {
        list-style-type: none;
      }
      ul.lst-kix_list_12-5 {
        list-style-type: none;
      }
      ul.lst-kix_list_12-4 {
        list-style-type: none;
      }
      ul.lst-kix_list_12-3 {
        list-style-type: none;
      }
      ul.lst-kix_list_12-2 {
        list-style-type: none;
      }
      ul.lst-kix_list_12-1 {
        list-style-type: none;
      }
      ul.lst-kix_list_12-0 {
        list-style-type: none;
      }
      ul.lst-kix_list_12-8 {
        list-style-type: none;
      }
      ul.lst-kix_list_12-7 {
        list-style-type: none;
      }
      .lst-kix_list_7-0 > li:before {
        content: "\\0025cf   ";
      }
      .lst-kix_list_2-6 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_2-4 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_2-8 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_7-1 > li:before {
        content: "o  ";
      }
      .lst-kix_list_7-5 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_7-3 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_7-5 {
        list-style-type: none;
      }
      .lst-kix_list_10-0 > li:before {
        content: "\\0025cf   ";
      }
      ul.lst-kix_list_7-6 {
        list-style-type: none;
      }
      ul.lst-kix_list_7-3 {
        list-style-type: none;
      }
      ul.lst-kix_list_7-4 {
        list-style-type: none;
      }
      .lst-kix_list_13-6 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_13-8 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_7-7 {
        list-style-type: none;
      }
      ul.lst-kix_list_7-8 {
        list-style-type: none;
      }
      ul.lst-kix_list_7-1 {
        list-style-type: none;
      }
      ul.lst-kix_list_7-2 {
        list-style-type: none;
      }
      ul.lst-kix_list_7-0 {
        list-style-type: none;
      }
      .lst-kix_list_7-7 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_15-4 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_15-6 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_10-4 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_10-8 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_4-0 > li:before {
        content: "\\0025cf   ";
      }
      ul.lst-kix_list_15-3 {
        list-style-type: none;
      }
      ul.lst-kix_list_15-2 {
        list-style-type: none;
      }
      .lst-kix_list_15-0 > li:before {
        content: "\\0025cf   ";
      }
      ul.lst-kix_list_15-1 {
        list-style-type: none;
      }
      .lst-kix_list_15-8 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_15-0 {
        list-style-type: none;
      }
      .lst-kix_list_10-2 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_4-4 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_15-8 {
        list-style-type: none;
      }
      .lst-kix_list_4-2 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_4-6 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_15-7 {
        list-style-type: none;
      }
      ul.lst-kix_list_15-6 {
        list-style-type: none;
      }
      .lst-kix_list_9-3 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_15-5 {
        list-style-type: none;
      }
      ul.lst-kix_list_15-4 {
        list-style-type: none;
      }
      .lst-kix_list_15-2 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_10-6 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_9-1 > li:before {
        content: "o  ";
      }
      .lst-kix_list_9-7 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_11-4 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_12-4 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_9-5 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_6-6 {
        list-style-type: none;
      }
      ul.lst-kix_list_6-7 {
        list-style-type: none;
      }
      ul.lst-kix_list_6-4 {
        list-style-type: none;
      }
      ul.lst-kix_list_6-5 {
        list-style-type: none;
      }
      ul.lst-kix_list_6-8 {
        list-style-type: none;
      }
      .lst-kix_list_12-2 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_11-6 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_1-0 > li:before {
        content: "\\0025cf   ";
      }
      ul.lst-kix_list_6-2 {
        list-style-type: none;
      }
      .lst-kix_list_11-8 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_6-3 {
        list-style-type: none;
      }
      .lst-kix_list_1-2 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_6-0 {
        list-style-type: none;
      }
      .lst-kix_list_12-0 > li:before {
        content: "\\0025cf   ";
      }
      ul.lst-kix_list_6-1 {
        list-style-type: none;
      }
      .lst-kix_list_1-4 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_13-0 > li:before {
        content: "\\0025cf   ";
      }
      ul.lst-kix_list_14-4 {
        list-style-type: none;
      }
      ul.lst-kix_list_14-3 {
        list-style-type: none;
      }
      ul.lst-kix_list_14-2 {
        list-style-type: none;
      }
      .lst-kix_list_13-4 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_14-1 {
        list-style-type: none;
      }
      ul.lst-kix_list_14-0 {
        list-style-type: none;
      }
      .lst-kix_list_1-6 > li:before {
        content: "\\0025aa   ";
      }
      li.li-bullet-0:before {
        margin-left: -18pt;
        white-space: nowrap;
        display: inline-block;
        min-width: 18pt;
      }
      ul.lst-kix_list_14-8 {
        list-style-type: none;
      }
      ul.lst-kix_list_14-7 {
        list-style-type: none;
      }
      .lst-kix_list_2-0 > li:before {
        content: "\\0025cf   ";
      }
      .lst-kix_list_12-6 > li:before {
        content: "\\0025aa   ";
      }
      ul.lst-kix_list_14-6 {
        list-style-type: none;
      }
      ul.lst-kix_list_14-5 {
        list-style-type: none;
      }
      .lst-kix_list_1-8 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_2-2 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_13-2 > li:before {
        content: "\\0025aa   ";
      }
      .lst-kix_list_12-8 > li:before {
        content: "\\0025aa   ";
      }
      ol {
        margin: 0;
        padding: 0;
      }
      table td,
      table th {
        padding: 0;
      }
      .c6 {
        margin-left: 36pt;
        padding-top: 0pt;
        padding-left: 0pt;
        padding-bottom: 14pt;
        line-height: 1;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      .c0 {
        background-color: #e0e0e0;
        padding-top: 0pt;
        padding-bottom: 0pt;
        line-height: 1;
        orphans: 2;
        widows: 2;
        text-align: left;
        height: 11pt;
      }
      .c5 {
        margin-left: 36pt;
        padding-top: 14pt;
        padding-left: 0pt;
        padding-bottom: 0pt;
        line-height: 1;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      .c19 {
        margin-left: 36pt;
        padding-top: 14pt;
        padding-left: 0pt;
        padding-bottom: 14pt;
        line-height: 1;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      .c2 {
        margin-left: 36pt;
        padding-top: 0pt;
        padding-left: 0pt;
        padding-bottom: 0pt;
        line-height: 1;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      .c13 {
        background-color: #e0e0e0;
        padding-top: 0pt;
        padding-bottom: 0pt;
        line-height: 1.0791666666666666;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      .c10 {
        color: #000000;
        font-weight: 400;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 11pt;
        font-family: "Calibri";
        font-style: normal;
      }
      .c11 {
        padding-top: 0pt;
        padding-bottom: 8pt;
        line-height: 1.0791666666666666;
        orphans: 2;
        widows: 2;
        text-align: left;
        height: 11pt;
      }
      .c4 {
        color: #9f7b0b;
        font-weight: 700;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 12pt;
        font-family: "inherit";
        font-style: italic;
      }
      .c14 {
        background-color: #e0e0e0;
        padding-top: 0pt;
        padding-bottom: 0pt;
        line-height: 1;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      .c16 {
        -webkit-text-decoration-skip: none;
        color: #3375c8;
        font-weight: 400;
        text-decoration: underline;
        text-decoration-skip-ink: none;
        font-size: 9pt;
        font-family: "Arial";
      }
      .c24 {
        color: #013972;
        font-weight: 400;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 21pt;
        font-family: "Times New Roman";
        font-style: italic;
      }
      .c7 {
        color: #000000;
        font-weight: 400;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 12pt;
        font-family: "Times New Roman";
        font-style: normal;
      }
      .c8 {
        color: #000000;
        font-weight: 400;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 9pt;
        font-family: "Arial";
        font-style: normal;
      }
      .c1 {
        color: #000000;
        font-weight: 400;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 9pt;
        font-family: "Times New Roman";
        font-style: normal;
      }
      .c22 {
        background-color: #e0e0e0;
        padding-top: 0pt;
        padding-bottom: 7.5pt;
        line-height: 1;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      .c9 {
        color: #171717;
        font-weight: 700;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 10.5pt;
        font-family: "inherit";
        font-style: italic;
      }
      .c15 {
        padding-top: 24pt;
        padding-bottom: 12pt;
        line-height: 1;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      .c3 {
        padding-top: 12pt;
        padding-bottom: 12pt;
        line-height: 1.0791666666666666;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      .c20 {
        padding-top: 0pt;
        padding-bottom: 0pt;
        line-height: 1;
        orphans: 2;
        widows: 2;
        text-align: center;
      }
      .c21 {
        padding-top: 8.1pt;
        padding-bottom: 12pt;
        line-height: 1;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      .c25 {
        font-size: 12pt;
        font-family: "Arial";
        color: #474747;
        font-weight: 700;
      }
      .c17 {
        font-size: 8.5pt;
        font-family: "Arial";
        color: #727272;
        font-weight: 400;
      }
      .c27 {
        font-size: 9pt;
        font-family: "Arial";
        color: #000000;
        font-weight: 400;
      }
      .c23 {
        color: #474747;
        font-weight: 700;
        font-size: 16.5pt;
        font-family: "Arial";
      }
      .c26 {
        background-color: #ffffff;
        max-width: 468pt;
        padding: 72pt 72pt 72pt 72pt;
      }
      .c18 {
        text-decoration: none;
        vertical-align: baseline;
        font-style: normal;
      }
      .c12 {
        padding: 0;
        margin: 0;
      }
      .title {
        padding-top: 24pt;
        color: #000000;
        font-weight: 700;
        font-size: 36pt;
        padding-bottom: 6pt;
        font-family: "Calibri";
        line-height: 1.0791666666666666;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      .subtitle {
        padding-top: 18pt;
        color: #666666;
        font-size: 24pt;
        padding-bottom: 4pt;
        font-family: "Georgia";
        line-height: 1.0791666666666666;
        page-break-after: avoid;
        font-style: italic;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      li {
        color: #000000;
        font-size: 11pt;
        font-family: "Calibri";
      }
      p {
        margin: 0;
        color: #000000;
        font-size: 11pt;
        font-family: "Calibri";
      }
      h1 {
        padding-top: 0pt;
        color: #000000;
        font-weight: 700;
        font-size: 24pt;
        padding-bottom: 8pt;
        font-family: "Times New Roman";
        line-height: 1;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      h2 {
        padding-top: 0pt;
        color: #000000;
        font-weight: 700;
        font-size: 18pt;
        padding-bottom: 8pt;
        font-family: "Times New Roman";
        line-height: 1;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      h3 {
        padding-top: 14pt;
        color: #000000;
        font-weight: 700;
        font-size: 14pt;
        padding-bottom: 4pt;
        font-family: "Calibri";
        line-height: 1.0791666666666666;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      h4 {
        padding-top: 12pt;
        color: #000000;
        font-weight: 700;
        font-size: 12pt;
        padding-bottom: 2pt;
        font-family: "Calibri";
        line-height: 1.0791666666666666;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      h5 {
        padding-top: 11pt;
        color: #000000;
        font-weight: 700;
        font-size: 11pt;
        padding-bottom: 2pt;
        font-family: "Calibri";
        line-height: 1.0791666666666666;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      h6 {
        padding-top: 10pt;
        color: #000000;
        font-weight: 700;
        font-size: 10pt;
        padding-bottom: 2pt;
        font-family: "Calibri";
        line-height: 1.0791666666666666;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      `}
      </style>
      <div className="max-w-3xl mx-auto p-6 bg-white dark:bg-teal shadow-md mt-6">
        <div className="flex items-center mb-4">
          <ScrollText className="text-yellow mr-2" />
          <h1 className="text-2xl font-bold dark:text-white">
            Terms and Conditions
          </h1>
        </div>

        <div className="max-w-4xl mx-auto px-4 py-8 text-white">
          <h2 className="text-2xl font-semibold mb-4">Online Betting Terms</h2>

          <p class="c20">
            <span class="c24">Online betting</span>
          </p>
          <p class="c21">
            <span class="c4">1 INTRODUCTION</span>
          </p>
          <p class="c15">
            <span class="c9">&nbsp;</span>
          </p>
          <p class="c3">
            <span class="c8">
              1.1.1.a.&nbsp;&nbsp; &nbsp;Amole Bet, registered in Ethiopia with
              address Addis Ababa, Bole Yeka 12, under sport betting license
              issued in accordance with sport betting license directive no.:
              172/2013 License no.: 140/2013 (hereinafter referred to as
              &ldquo;the company &ldquo;) operates the sports betting website
              www.Amole.bet (hereinafter referred to as &ldquo;internet sports
              betting &ldquo;).
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              This Terms and Conditions for operating the internet sports
              betting is binding for any legal relationship between the client
              and the company. The ignorance of the Terms and Conditions
              doesn&acute;t make the bet invalid.
            </span>
          </p>
          <p class="c3">
            <span class="c1">1.General</span>
          </p>
          <p class="c3">
            <span class="c1">
              1.1. This agreement establishes the Terms and Conditions that will
              govern the contractual relationship between the Company and you as
              a Registering /Participating Player with the company. The Terms
              shall apply to gaming via all media/electronic platforms including
              but not limited to mobile devices, computers and laptops. You are
              required to accept these Terms and Conditions when registering for
              an account with the Company and you are bound by these Terms and
              Conditions throughout the existence of the relationship. The
              company reserves the right to decline your registration/
              participation without being bound to provide any reasons
              whatsoever at any time.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              1.2. These Terms and Conditions are categorized for ease of
              reference and understanding. It is important that you make
              yourself aware of these Terms and Conditions as a participating
              player. Reference to &quot;you&quot;, &quot;your&quot;, the
              &quot;player&quot;, &quot;customers&quot;, or
              &quot;subscriber&quot; is reference to any person using the
              Company gaming/betting platform or the services and/or any
              registered customer of the Company thereof. Reference to &quot;the
              Company&quot;, &quot;us&quot;, &quot;Our&quot; &quot;we&quot; is
              reference to Amole and or its successors in title and assigns.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              1.5. The Company reserves the right to change these Terms and
              Conditions at any time and without prior notice. The Company will
              endeavor to inform you about major modifications to the Terms and
              Conditions. Nevertheless, it is your responsibility to regularly
              check for any changes. Should you, due to any possible changes,
              not wish to continue using the services of the Company, you can
              withdraw uncommitted funds without penalty and close the account
              by sending a message to our support team, to that effect. A
              response will be sent to you within 48 hours confirming receipt of
              your decision to discontinue your engagement with the Company, If
              there&rsquo;s no any fraud found in your account, after blocking
              the account The Company will return your funds within 48 hours.
              But if there is fraud took place in your account then the Company
              blocks your account and if there are fund leavings in your account
              The Company returns or levy those. Failure by you to receive a
              message for any reason whatsoever shall not be taken to mean that
              the Company has any continued obligation towards you from the date
              of your withdrawal.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              1.6. The Company will respect your privacy in line with the
              Company&#39;s privacy policy and will endeavor to at all times
              preserve your information in the strictest confidence as it
              possibly can. The Company shall not be liable for any loss of data
              by itself or by other contracted independent service providers on
              whom the Company will wholly or partially be reliant on to deliver
              the services.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              1.7. The Company will not disclose your personal information to
              third parties unless such disclosure:
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              (a) is required for the processing of your requests;
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              (b) is a duty and/or legal obligation of the company;
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              (c) is required to enforce/ apply the Terms and Conditions and
              other agreements;
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              (d) is required to adequately protect our rights or property,
              including via the exchange of information with other companies and
              organizations for the purposes of information verification, fraud
              protection and credit risk reduction. Personal information that
              you provide may be disclosed to a credit reference agency, which
              may keep a record of the information.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              1.8. By agreeing to these Terms and Conditions and where you play
              any game, or place a bet or stake, using the provided betting
              platforms, you accept and agree to be bound by these terms and
              conditions and any amendment or variation thereto and the Rules
              which apply to the applicable products available from time to
              time. You are acknowledging that the company shall retain the
              right to use from time to time, all data collected to carry out
              market survey/ campaign /research, send customer satisfaction
              questionnaires, market and promote its services and those of its
              affiliated companies.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              1.9. The Company is not responsible for any consequences resulting
              from major incidents such as any strike, terrorist activities,
              political crisis, war, natural catastrophe and saturation of the
              telecommunication networks, cyber-attacks, hacking etc., which
              could lead to a total or partial access reduction to its services,
              loss of data by itself or by other contracted independent service
              providers on whom the Company will wholly or partially be reliant
              on to deliver the services.
            </span>
          </p>
          <p class="c3">
            <span class="c1">2.ACCOUNT RULES</span>
          </p>
          <p class="c3">
            <span class="c1">
              2.1. To apply for an account, you must be of legal age and
              register personally. You must provide your age in the provided
              fields and confirm the same in the registration field. The Company
              reserves the right to ask for proof of age from any customer and
              suspend their account until satisfactory documentation is
              provided. The name of the player MUST be the same as the name used
              when registering with the company and must correspond with the
              registered mobile number. Where this is not the case, the relevant
              account will be suspended. Where an account is suspended, the
              relevant customer should Contact Us. All bets/stakes that are
              placed prior to an account being suspended will stand-win, lose or
              returned. Should any underage account owner be discovered at any
              point during the lifetime of the account, the account will
              immediately be closed indefinitely and all funds deposited to the
              account will be forfeited. In any such suspected circumstance, the
              Company will report the activity to the appropriate authority and
              the player may suffer the consequences thereto. You agree to
              provide all such information as we require in connection with such
              verification checks. We shall be entitled to suspend or restrict
              your account in any manner that we may deem in our absolute
              discretion to be appropriate, until such time as the relevant
              checks are completed to our satisfaction.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.2. You agree to abide by these &quot;Terms and Conditions&quot;
              at all times, and:
            </span>
          </p>
          <ul class="c12 lst-kix_list_4-0 start">
            <li class="c5 li-bullet-0">
              <span class="c7">
                (a) not to be acting in the interests of any third party;
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (b) not to utilize money obtained from ill-gotten means;
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (c) not to transfer funds to accounts you are not authorized to
                use;
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (d) not to try to hack the Company Mobile service, Website and
                all other media/electronic platforms, or to alter its code in
                any way in an attempt to cheat, override or manipulate the
                system or in any way commit fraud or any other crime;
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (e) not to adopt any criminal behavior against the Company, its
                affiliates, its customers or any third party;
              </span>
            </li>
            <li class="c6 li-bullet-0">
              <span class="c7">
                (f) not to mislead the Company by intentionally providing false
                information which may be in the form of but not limited to
                invalid account details, forged documentation, concealing
                one&#39;s identity, untruthful behavior or hiding one&#39;s true
                location and/or age.
              </span>
            </li>
          </ul>
          <p class="c3">
            <span class="c1">
              2.3. In the event that you breach one or more of the Account rules
              as mentioned in 2.1 and 2.2, the Company reserves the right to
              close your account and seize any available funds. In any such
              suspected circumstance, the Company will report the activity to
              the appropriate authority and the player may suffer the
              consequences thereto. Contractual obligations will be honored
              unless there is any breach of any of the terms and conditions on
              your part or breach of any international law and laws of Ethiopia.
              The specific games/products shall be strictly guided by these
              rules &amp; guidelines herein and all other Rules &amp; guidelines
              that shall be issued from time to time by the Company. The
              products, guidelines and Rules shall remain at all times the
              property of the Company.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.4. At all times during your subscription/participation, it is
              your responsibility to ensure that you are not violating any laws
              in your jurisdiction when opening an account and engaging with the
              Company. Users must ensure they are physically located within
              Ethiopia to access and participate in betting activities on Amole.
              Betting and playing on Amole&nbsp;are strictly prohibited outside
              of Ethiopia.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.5. You must submit the correct information during your
              registration. You agree to update this information should there be
              any changes to your registration data.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.6. The Company will accept no liability from third parties
              whatsoever, resulting from your providing incorrect or false data.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.7. Each customer must open only one account. Should we identify
              any customer with more than one account, we reserve the right to
              close these accounts.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.8. If the Company detects multiple accounts which have been
              setup deliberately with misleading information, have displayed
              criminal behavior, or if the Company concludes that the
              account-owner has fraudulent intentions, the Company shall be
              entitled to close the accounts and confiscate all funds, including
              the initial deposit. In any such suspected circumstance, the
              Company will report the activity to the appropriate authority and
              the player may suffer the consequences thereto. If you nominate
              another person as an authorized user of your account, you shall be
              responsible for all transactions such a person makes using the
              relevant account details. Should you lose your account details or
              feel that someone else may have your account details, please
              contact us immediately. The Company will however not be
              responsible for any loss or damage that you may suffer as a result
              of transaction made by that other person. Please note that
              personal registration details and any other sensitive data should
              never be shared with third parties or sent to us by any
              unencrypted form.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.9. The Company manages players&#39; accounts and calculates
              available funds, pending funds, betting funds, any applicable tax,
              as well as the amount of the winnings. Unless proven otherwise,
              these amounts are considered as final and are not subject to
              challenge.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.10. All account transactions are performed in Ethiopian
              SHILLINGS.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.11. The Company is not a financial institution and shall not be
              used as an intermediary to transfer funds, used or unused with or
              without ill intentions as well as using the Company as a currency
              exchange bureau. Should you conduct account activities for these
              purposes, the Company reserves the right to close your account
              and/or seize any available funds available in the account.
              Contractual obligations will be honored unless there is a breach
              of any of the terms and conditions. No credit will be offered by
              the Company or from any employee of the Company, and all bets must
              be supported by sufficient funds in the customer&#39;s account.
              The Company reserves the right to void any bet/stake which may
              have inadvertently been accepted when the account did not have
              sufficient funds. Should funds be credited to a customer&#39;s
              account in error, it is the customer&#39;s responsibility to
              inform the Company without delay. The Company will recover such
              funds by account adjustment.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.12. The Company does not tolerate abusive, aggressive or obscene
              language/ behavior towards representatives of the Company across
              any of our support platforms (chat, email, telephone, outlets).
              Should you decide to communicate with us in this manner, you will
              be denied access to any and all of our support platforms and any
              such acts will be reported to the relevant authority for action.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.13. You must keep your login ID and password secret at all
              times. It is your sole responsibility to ensure that your login
              information is kept secure. Should you suspect that your login
              information is no longer secure you are required to immediately
              contact the company as well as change your security details
              immediately. If at any time your account is accessed and used by a
              third-party without your prior consent, the Company is not liable
              for any consequences that may occur.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.14. Selling and/or transferring and/or, acquiring of accounts
              to/from other players, is prohibited. Any such action will lead to
              closure of the account and forfeiture of the funds in such
              account. The company may in its sole discretion reopen an account
              if there is sufficient proof to the satisfaction of the company
              that a transfer was done in error.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.15. A dormant account is an account that has not been accessed
              for 3 months, that has a legal registration with or without money
              balance. Once your account becomes dormant, the Company, shall in
              its sole discretion, close your account and thereafter either
              refund the balance to you or where applicable deal with it in the
              manner provided for in law less any cost accruing thereon.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.15.1. The company prohibits to create more than one account from
              the same device and/ or IP address. Additionally, the use of VPNs,
              anonymizers, or other software solutions that may hinder the
              collection of information from the device or internet is strictly
              forbidden.
            </span>
          </p>
          <ul class="c12 lst-kix_list_5-0 start">
            <li class="c5 li-bullet-0">
              <span class="c7">
                (a) the Company considers that you have used the
                services/products/platforms in a fraudulent manner or for
                illegal and/or unlawful or improper purposes;
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (b) the Company considers that you have used the
                services/products/platforms in an unfair manner or have
                deliberately cheated or taken unfair advantage of the Company or
                any of its customers;
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (c) the Company is requested to do so by the police, any
                regulatory authority or court; or
              </span>
            </li>
            <li class="c6 li-bullet-0">
              <span class="c7">
                (d) the Company considers that any of the events referred to in
                (a) to (c) above may have occurred or are likely to occur.
              </span>
            </li>
          </ul>
          <p class="c3">
            <span class="c1">
              2.15.2. If the Company closes or suspends your account for any of
              the reasons above, you shall be liable for any and all claims,
              losses, liabilities, damages, costs and expenses incurred or
              suffered by the Company (together &quot;Claims&quot;) arising
              there from and shall indemnify and hold the Company harmless on
              demand for such Claims. The Company shall also be entitled to
              withhold and/or retain any and all amounts which would otherwise
              have been paid or payable to you (including any winnings or bonus
              payments).
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.15.3. In addition, the Company shall be entitled to withhold
              and/or retain any and all amounts earned or received by you as a
              result of or in connection with your &quot;unauthorized&quot; use
              of the services/products/platforms including activities which are
              not for an authorized purpose.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.15.4. Where it is proved that these Terms and Conditions have
              not been breached, any funds available in the account will be
              returned to the player should the relationship be terminated by
              the Company. At all times, any funds deposited by a
              subscriber/player, do not accrue any interest and as such any
              refunds made shall not incorporate any interest calculations.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.15.5. The Company prohibits and takes measures to prohibit use
              of devices, such as robots, computers that distort normal and fair
              game play. Should the use of such electronic added devices be
              discovered, the Company will disqualify such player(s), close all
              such accounts and confiscate all funds and earnings due to such
              accounts. In any such suspected circumstance, the Company will
              report the activity to the appropriate authority and the player
              may suffer the consequences thereto.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.16. You will be liable for any taxes levied pursuant to the
              legislation prevailing at the material time or as may be assessed
              by the tax authorities. These taxes will be paid out or withheld
              at source (as the case may be) in accordance with the provisions
              of law.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.17. The company reserves the right to demand verification for
              the following cases:
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.17.1. When there is 5 million ETB or more in user&#39;s balance.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.17.2. When the user wants to withdraw an amount of 1 million. or
              more.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.17.3. When the user wants to recover the account deleted by him.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.17.4. When the user wants to change his phone number.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.17.5. When the user is suspected in illegal activities or in
              fraud or any suspicious transactions
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.17.6. When there is taking place a promotion (which includes
              verification in conditions)
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              The company can ask for passport, driving license or ID card
              pictures for verification. If the verification is not done within
              72 hours the company reserves the right to suspend user&#39;s
              account at all. Within 30 days after suspend if the user provides
              all documents needed the account recovers.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              2.17.7&nbsp;In the case of any promotion, the company may require
              verification in case of suspicion of fraud (in accordance with
              point 2.17.6), if the information provided does not inspire
              confidence, the company may request additional verification of
              other parameters.&nbsp;
              <br />
              In case of any suspicion of fraud, the company reserves the right
              to eliminate bonuses (points, money, opportunities, privileges,
              etc.), the company also reserves the right to nullify the amount
              in the account (returning the initial deposit or returning a
              certain percentage of the initial deposit or confiscate the entire
              balance funds).
              <br />
              In such cases, the company is ready to discuss the issue (with
              facts) in the presence of the relevant law enforcement agencies.
            </span>
          </p>
          <p class="c3">
            <span class="c1">3. Deposits, transfers and withdrawals</span>
          </p>
          <p class="c3">
            <span class="c1">
              3.1. For all deposits, the Number of the depositor must be
              identical to the mobile phone number registered on the Company
              account receiving the funds i.e. the registered account. Any
              charges levied by the Mobile Operators payment gateways (MPesa and
              Airtel Money) will be deducted from the player&#39;s account. You
              should only deposit money in your account for the purposes of you
              using such money to place bets/stakes on our platforms. We shall
              be entitled to suspend or close your account if we reasonably
              consider or have reason to believe that you are depositing money
              without any intention to place bets/stakes. You may only bet/stake
              if you have sufficient funds in your account.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              3.2. Bonus funds may be credited to your account as part of a
              promotion, loyalty or other marketing campaign. These funds cannot
              be directly withdrawn/paid-out, but must be used for placing bets
              (available only for sports, not for casino and other games).
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              3.3. You can at any time login to your account and view a
              statement showing all transactions made within the last 30
              Calendar days. Should you notice any mistakes you should
              immediately notify the Company. Such error will be rectified by
              the company in the shortest time possible at no cost to you.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              3.4. You can withdraw your money any time in accordance with the
              terms herein. We have a number of controls and checks that take
              place before any withdrawal request is processed. Thereafter, an
              SMS with a verification code will be sent to you. These checks are
              part of our ongoing commitment to maintaining the security of our
              customers&#39; funds. All withdrawals requests cannot be processed
              after the expiry of fifteen (15 minutes) from the withdrawal
              request being made. If the customer is not included into the
              scammer list and not suspected in fraud, in case of suspicious
              transaction, the latter can be left with no response within 30
              days and even levied.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              3.5. Where possible, all valid withdrawals will be processed to
              the payment account from which the deposits were validly made.
              Withdrawal payments can only be made in the name of and to the
              registered account holder. For most payment types, withdrawals can
              be processed by following the withdrawal protocol steps provided,
              subject to there being sufficient funds in your betting account.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              3.6. In case of not playing 50% of deposit, the Company has all
              the rights to deny the transaction. Except the first deposit,
              which was done as a probation, but the probation deposit
              shouldn&rsquo;t be more than double of minimal deposit.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              For full details on each specific payment type, please call
              customer care.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              3.7. If we incur any charge-backs, reversals or other charges in
              respect of your account, we reserve the right to charge you for
              the relevant amounts incurred.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              3.8. The Company may, at any time, set off any positive balance on
              your account against any amounts owed by you to the Company.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              3.9. In the event that you access the services from jurisdictions
              outside Ethiopia, you shall be responsible for reporting your
              winnings and losses to the tax and/or other authorities as per the
              existing regulations within in your jurisdiction.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              3.10. Gaming/staking, gambling may be illegal in the jurisdiction
              in which you are located. Where you attempt to transact on our
              platform from jurisdictions where staking/gaming is illegal, you
              do so at your own risk and the Company will not bear any liability
              towards you.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              3.11. The Company reserves the right to take time necessary for
              the purpose of:
            </span>
          </p>
          <ul class="c12 lst-kix_list_6-0 start">
            <li class="c5 li-bullet-0">
              <span class="c7">(a) verifying your identity;</span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">(b) verifying your gaming activity;</span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (c) conducting security and other internal procedures in
                relation to your account; and
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (d) ensure that prizes offered are paid out to the rightfully
                registered customer.
              </span>
            </li>
            <li class="c6 li-bullet-0">
              <span class="c7">
                (e) require the user to withdraw the money through the
                registration number
              </span>
            </li>
          </ul>
          <p class="c3">
            <span class="c1">
              3.12. If you want to close your account, please contact our
              customer service team. If by any chance, your account reflects a
              negative balance, you should inform about the issue to the
              customer service team immediately without making any other
              transaction.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              3.13. Where a player wins, and is pronounced dead before claiming
              the winnings, the dependents or family can only claim the amount
              with the appropriate court orders e.g Confirmation of Grant.
            </span>
          </p>
          <p class="c3">
            <span class="c1">3.14 Max. and min. deposits and withdrawals:</span>
          </p>
          <ul class="c12 lst-kix_list_7-0 start">
            <li class="c5 li-bullet-0">
              <span class="c7">(a) Min. Deposit - 100 ETB</span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">(b) Min. Withdraw - 1000 ETB</span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">(c) Max. Deposit - No limit</span>
            </li>
            <li class="c6 li-bullet-0">
              <span class="c7">(d) Max. Withdraw -1,000,000 ETB (daily)</span>
            </li>
          </ul>
          <p class="c3">
            <span class="c1">3.15 The Accessible Withdraw Amount (AWA)</span>
          </p>
          <p class="c3">
            <span class="c1">
              The accessible withdrawal amount is calculated based on several
              actions of the customer. The steps are as follows:
            </span>
          </p>
          <ul class="c12 lst-kix_list_8-0 start">
            <li class="c5 li-bullet-0">
              <span class="c7">DEPOSIT</span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">BET</span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">WIN</span>
            </li>
            <li class="c6 li-bullet-0">
              <span class="c7">WITHDRAW</span>
            </li>
          </ul>
          <p class="c3">
            <span class="c1">
              (a)If the user deposits, doesn&#39;t spend half of it and
              doesn&rsquo;t win, his/her AWA is equal to the amount of
              betting(s).
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              (b)If the user deposits, doesn&rsquo;t spend half of it and wins,
              his/her AWA is equal to the amount of betting(s) + the amount of
              winning(s).
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              (c)If the user deposits, spends half of the deposit and
              wins(doesn&#39;t win), his AWA is equal to the balance.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              (d) If the user deposits twice in a row or more (eg. 5.000 + 5.000
              ), his deposit becomes 10.000. If the user doesn&rsquo;t spend
              half of 10.000 and doesn&rsquo;t win, his/her AWA is equal to the
              amount of user betting(s). In case of winning his AWA is equal to
              the amount of betting(s) + the amount of winning(s).
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              (e)If the user deposits, places bets, doesn&rsquo;t spend half of
              it and deposits again, his/her AWA is equal to the amount of
              betting(s) after the first deposit.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              (f)If the user deposits, places bets, doesn&rsquo;t spend half of
              it and deposits If the user deposits, places bets,doesn&rsquo;t
              spend half of it, wins, and deposits again, his/her AWA is equal
              to the amount of betting(s) + the amount of winning(s) after the
              first deposit.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              (g)If the user deposits, places bets, doesn&rsquo;t spend half of
              it, deposits again and doesn&rsquo;t spend half it, his/her AWA is
              equal to the amount of betting(s) after the first deposit + the
              amount of betting(s) after the second deposit.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              (h) If the user deposits, places bets, doesn&rsquo;t spend half of
              it, wins, deposits again, places bets, wins and again
              doesn&rsquo;t spend half of the second deposit, his/her AWA is
              equal to the amount of betting(s) + the amount of winning(s) after
              the first deposit + the amount of betting(s) + the amount of
              winning(s) after the second deposit.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              (i)In case of spending half of the two deposits, the user&#39;s
              AWA becomes his/her balance.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              3.16 If the user succeeded to win the Jackpot,the user is to
              withdraw the won amount partially. Max withdraw -20.000.000 ETB
              monthly.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              3.17 The company reserves the right to apply individual limits on
              customers, to raise or lower limits.
              <br />
              The limit set on point 3.14 can be connected with the
              customer&#39;s behaviour.
            </span>
          </p>
          <p class="c3">
            <span class="c1">&nbsp;</span>
          </p>
          <p class="c3">
            <span class="c1">4. Betting Rules and Type of bets</span>
          </p>
          <p class="c3">
            <span class="c1">4.1. Definitions</span>
          </p>
          <p class="c3">
            <span class="c1">
              In these rules the following words have the following meanings
              unless the context requires otherwise:
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.1.1. &quot;Bet&quot; means- the staking of money on the
              prediction of the outcome of a sporting event.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.1.2. &quot;Odds&quot; means- the return on the money staked
              should the prediction recorded in a bet be correct. The odds paid
              are those at the time the bet is placed and no other.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.1.3. &quot;Customer&quot; means- anyone placing a bet with the
              Company.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.1.4. &quot;User&quot; means- anyone using this website.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.1.5. &quot;VOID&quot; means- that for one reason or another, a
              bet is not acceptable to the Company. In these cases, this bet, or
              part of the bet, is settled at the odd of 1.00. In the case of
              multiple/combination bets, the invalid result will not be included
              in the calculation of the (total) odds. In the case of a single
              bet this would mean the stake is returned to the customer.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.1.6. Full time (FT) means- The point when the official 90
              minutes of a full match has elapsed, plus time added on by the
              referee to compensate for injuries to players that require
              treatment, substitutions or deliberate time-wasting by players
              (also called &quot;stoppage time&quot;). Full time Shall NOT
              include scheduled extra time (two half times of 15 minutes each),
              penalty shoot-outs etc.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.1.7. First Half (HT1) means- The point when the official 45
              minutes of the first half of the match has elapsed, plus time
              added on by the referee to compensate for injuries to players that
              require treatment, substitutions or deliberate time-wasting by
              players (also called &quot;stoppage time&quot;). Bets on First
              Half markets are settled at the end of the Full Time.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.1.8. Over/Under 1.5 - First Half means- If you BET OVER 1.5
              goals to be scored, you win when there are 2 or more goals scored.
              If you BET UNDER 1.5 goals to be scored, you win when there are 0
              or 1 goals scored.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.1.9. Over/Under 2.5 means- If you BET on OVER 2.5 goals to be
              scored, you win if there are three or more goals scored. If you
              BET on UNDER 2.5 goals, you win if there are two or less goals
              scored i.e. 0, 1, or 2 goals.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.1.10. Correct Score means- Bet on the exact number of goals
              scored by each team within the official Full time. For betting
              purposes, own goals count for the team in whose favor they have
              been scored.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.1.11. Correct Score- First Half means- Bet on the exact number
              of goals scored by each team at the end of the first half of the
              match. For betting purposes, own goals count for the team in whose
              favor they have been scored.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.1.12. Both teams to score means- Predict if both teams will
              score at least one goal each within the Full time of the match or
              not.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.1.13. Odd/Even means- Predict whether the total goals in the
              match would be odd (1, 3, 5, 7...) or even (2, 4, 6, 8...). 0
              (zero) goals will be settled as EVEN. Own goals count.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.1.14. Total Goals Exactly means- Predict the exact total number
              of goals scored within the full time.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.1.15. Half Time/Full Time means- Predict the result of a match
              both at the end of the First Half time and Full Time.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.1.16. Double Chance means- Predict either two out of three
              possible outcomes of a match with one bet.
            </span>
          </p>
          <p class="c3">
            <span class="c1">The following options are available:</span>
          </p>
          <ul class="c12 lst-kix_list_9-0 start">
            <li class="c5 li-bullet-0">
              <span class="c7">
                (a) 1 or X - the result is either a home win or draw;
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (b) X or 2 - the result is either a draw or away win;
              </span>
            </li>
            <li class="c6 li-bullet-0">
              <span class="c7">
                (c) 1 or 2 - the result is either a home win or away win.
              </span>
            </li>
          </ul>
          <p class="c3">
            <span class="c1">
              4.1.17.&nbsp;Basketball- The highest scoring quarter considers to
              be the quarter where the amount of points of both teams are the
              greatest. If the quantity of periods is more than 1 the outcome X
              is won.
              <br />
              Hockey-&nbsp;The highest scoring period considers to be the period
              where the amount of points of both teams are the greatest. If the
              quantity of periods is more than 1 the outcome X is won.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.2. You can only place a bet if you have successfully registered
              with the Company and a confirmation to that effect has been issued
              to you.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.3. You can only place a bet if you, have sufficient funds.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.3.1. All bets accepted by the Company are settled on Full Time,
              unless otherwise stated.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.3.1.1. For matches that are scheduled for an unusual duration
              (e.g. 60, 80, or 120 minutes) as stipulated by the laws of the
              competition or as agreed by both sides prior to kick-off, all
              accepted bets will be settled at the end of the applicable game
              length, as the case may be, which includes time added on by the
              referee for stoppages (but excludes extra time and penalty
              shoot-outs), whether the game length is advertised by us or not.
              This provision would apply, for example, in the case of friendly
              matches or tournaments.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.3.1.2. If the game is played in an unusual format (e.g. 3 or 4
              periods) then all bets will be voided.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.3.2. Any bet accepted after the kick-off will be settled at the
              discretion of the company.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.3.3. Where the match is postponed, cancelled, abandoned,
              interrupted or suspended in the case of a multi-bet, the
              particular game resulted with an odd of 1.00. This means that the
              total odds will be adjusted accordingly and the multi bet can
              still be won, if all other bets are won too.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.3.4. In the case of any subsequent replays/completions, award of
              the match result by governing bodies or pools, panel decisions,
              will not count toward settlement.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.3.4.1 If the reserve player gets yellow card, then the following
              yellow card is not calculated as a yellow card and is not included
              in any market calculation. If the coach gets a yellow card, then
              the following yellow card is not calculated as a yellow card and
              is not included in any market calculation.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.3.5. In the instance where a match is postponed, cancelled,
              abandoned, interrupted or suspended the following principles will
              be applied in settling bets:
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.3.5.1 If the event was delayed for any reason with not
              determined or determined period (the time of which is more than 24
              hours) all the tickets will be voided and the amount will be
              returned to the customer. Tickets with the events which were
              launched and suspended before 70th minute of game, and if the
              event is going on within 24 hours, the actual results will come up
              and be counted after the end of game. Tickets with the events
              which were suspended before 70th minute of game, and if the event
              is not going on within 24 hours, tickets are consider to be void
              and funds will be returned to the customer.
              <br />
              <br />
              4.3.5.2. If a match is abandoned/ suspended after 70th minute the
              results are being calculated according to the official result
              announced by the organizers.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.3.6. In -Play betting - where we have reason to believe that a
              bet is placed after the outcome of an event is known, or after the
              selected participant or team has gained a material advantage (e.g.
              a score, sending off for the other team etc.) we reserve the right
              to void the bet.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.3.7. If, for any reason we are unable to validate the outcome of
              a particular market (e.g. due to loss of live coverage), the
              particular ticket can carry pending status for 24 hours, in case
              of lack of official results after 24 hours, funds should be
              returned to the customer.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.3.8. By placing a bet, you confirm your willful intention to
              conclude such a transaction. A bet, once concluded, will be
              governed by the version of Terms and Conditions valid at the time
              the bet was accepted.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.3.9. The company assumes no responsibility for typing,
              transmission and/or evaluation errors. In particular, the company
              reserves its right to correct obvious errors - even after the
              event - with the input of betting odds and/or the evaluation of
              betting results (e.g. odds-related, team-related, event-related
              errors) or declare affected bets void. The company also assumes no
              liability for correctness, completeness or up-to-minute
              preciseness of the information services provided, for example live
              scores and result messages sent via e-mail or SMS. The stake is
              exclusively the amount confirmed and recorded by the company. In
              case the erroneous event/market is cancelled all bets are void and
              will be evaluated as &quot;won&quot; with odds of 1.00.
            </span>
          </p>
          <p class="c3">
            <span class="c1">4.4. Acceptance and Cancelation of bets</span>
          </p>
          <p class="c3">
            <span class="c1">
              4.4.1. Once accepted, a bet placed can be cancelled within 2 (two)
              hours of placing the bet. prior to the kick off of the game.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.4.2. The Company reserves the right to decline all, or part, of
              any bet/stake requested at its sole and absolute discretion. All
              bets/stakes are placed at your own risk and discretion.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.4.3. We only accept bets/stakes made via mobile device, the
              Company website, USSD (Unstructured Supplementary Service Data),
              Android Application or cash desk. Bets/stakes are not accepted in
              any other form (post, email, fax, etc.) and where received will be
              void.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.4.4. It is the responsibility of the customer to ensure details
              of their bets/stakes are correct.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.4.5. Bets/stakes are processed in the order they are received.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.5. You agree that at the time you placed your bet(s), you had no
              knowledge as to the outcome of the respective event(s). You are
              not allowed to bet on events where you are directly involved or
              have access to insider information. Where there is suspicion of
              collusion / fraud or any activity leading to the violation of this
              rule, the Company retains the right to void the bet and to refuse
              the winnings. The Company also retains the right to take any
              further action to protect its legitimate interests and to comply
              with local and international laws and regulations. Any suspicious
              activities may also be submitted to various monitoring agencies
              that are set up to protect and uphold the integrity of sports and
              betting.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.6. Should a number of bets containing the same selection be
              placed the Company reserves the right to accept one (1) bet and
              refund others, and if the Company have reason to believe the bets
              have originated from one customer or group/syndicate of customers
              acting together, the Company reserves the right to accept only one
              (1) bet of one (1) bettor and return others&rsquo; bets. In case
              of software failure or technical error, the Company reserves the
              right to return the stake.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.7. The Company reserves the right to declare all bets on an
              event/s invalid if they emanate from a group of players who appear
              to have had knowledge of the outcome of such event/s, e.g.
              syndicate betting.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.8. Any individual or group of individuals deemed to be working
              as a team (syndicate), who manipulate promotions or any other
              offer will have their account closed immediately. Moreover, the
              transactions (bets) in question will not contribute to any
              promotion or bonus offer requirements.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.9. The Company further reserves the right to reclaim any bonus
              given to you, and to reduce such amount from the bet stake, where
              you are found to be abusing the system as laid out in the
              provisions herein.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.10. Should the Company decide to close your account for any
              reason, bets which have already been placed and accepted within
              the general Terms and Conditions and sports rules will not be
              voided, and you will be paid any accrued winnings at the
              discretion of the company. Should security questions arise in
              relation to an account, the Company reserves the right to void
              such transactions (bets) within the legal and regulatory scope,
              retain and exercise its right of lien on such winnings and remit
              any amounts less any applicable charges.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.11. When you place a bet, you acknowledge that you have read,
              understood and accepted in full all of the Terms and Conditions
              and Sports Betting Rules regarding the bets offered by the Company
              as stated on the Company Website and all other media/electronic
              platforms.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.12. Winnings will be paid into your account after the final
              result is confirmed. Any later amendment to the result, e.g.
              disciplinary procedures (doping) or intervention by ruling bodies
              which lead to a post-event modification of the result, will not be
              taken into account for the purpose of determining the outcome of a
              bet. However, the Company reserves the right to set aside any
              winnings, should there be investigations into an event as a result
              of a suspicion of criminal activities that may have affected the
              result of the event. If any irregularity is confirmed, the Company
              retains the right to void any related bets.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.13. In the case of multiple bets (e.g. doubles, trebles,
              4-folds, etc.) placed in the form of a combination of multiples
              through the bet slip (e.g. 3 X Doubles, 2 X Trebles), all bets
              submitted through this combination will be settled once the final
              event in the combination has been settled. For example, should you
              select three markets in your bet slip and place the maximum
              combination of three Doubles, all three Doubles will not be
              settled until the final market has been settled*.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              *Some matches may have a FT period of eighty or seventy (80 or 70)
              minutes as per FIFA regulations such matches include; U/16, U/17,
              Women Seniors, some international friendly games etc.
            </span>
          </p>
          <p class="c3">
            <span class="c1">4.14. Minimum and maximum bet stakes:</span>
          </p>
          <ul class="c12 lst-kix_list_10-0 start">
            <li class="c5 li-bullet-0">
              <span class="c7">
                (a) Minimum Bet Amount: The minimum betting amount for Keno is
                ETB. 50. The minimum betting amount for a single/multi bet is
                ETB. 50.
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (b)The maximum wager for single and multi-bets varies across
                different games and positions. To determine the allowable bet
                amount for your preferred game position, simply click on the
                &#39;Max Bet&#39; button within the betslip section.
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (c) Maximum Multi/single bet Winning: The Multi/single bet
                winning amount is limited to ETB. 100000.
              </span>
            </li>
            <li class="c6 li-bullet-0">
              <span class="c7">
                (d) Maximum Multi/single bet Winning: The Multi/single bet daily
                winning amount is limited to ETB. 100000.
              </span>
            </li>
          </ul>
          <p class="c3">
            <span class="c1">
              4.15. The bet sizes set afore are subject to change at the
              Company&rsquo;s discretion. You are not permitted to place bets or
              try to place bets that are below the minimum bet limit or exceeded
              the maximum bet sizes thresholds.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.16. All bets and stakes are subject to the Betting Coverage
              provisions (including maximum winnings) set out in these Terms and
              Conditions including:
            </span>
          </p>
          <ul class="c12 lst-kix_list_11-0 start">
            <li class="c5 li-bullet-0">
              <span class="c7">
                (a) The Company reserves the right to suspend and/or cancel any
                bet/stake at any time. When a bet/wage/or gaming is suspended,
                any bets entered will be rejected. The Company also reserves the
                right to cease betting on any region within the jurisdiction at
                any time without notice.
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (b) Winnings from settled bets/stakes are added to the balance
                of your betting account. Any funds/winnings credited to an
                account in error are not available for use, and the Company
                reserves the right to void any transactions involving such funds
                and/or withdraw the relevant amount from your account and/or
                reverse the transaction, either at the time or retrospectively.
              </span>
            </li>
            <li class="c6 li-bullet-0">
              <span class="c7">
                (c) For events where there is no official &#39;kick off&#39;
                declared, the advertised start time of the event will be deemed
                to be the &#39;kick off&#39;. If for any reason a bet is
                inadvertently accepted after an event or match has commenced,
                bets will stand providing the final outcome is not known, and
                that no participant/team has gained any material advantage (e.g.
                a score, sending off for the other team, etc.) at the time the
                bet was placed. If the outcome of an event/market is known, the
                Company reserves the right to void the bet, win or lose.
                Disputes over times bets are placed will be settled using the
                transaction log. All times stated on the Mobile service, Website
                and all other media/electronic platforms and/or referred to by
                Company staff relate to Kenyan Time unless stated otherwise.
              </span>
            </li>
          </ul>
          <p class="c3">
            <span class="c1">
              4.17. The Company does not assume liability for input or
              transmission errors. The Company reserves the right to rectify
              obvious errors in particular in the input of bet odds e.g.
              confusion of odds or results, teams, etc.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.18. The Company assumes no liability for correctness or
              completeness of information provided.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.19. The Company assumes no liability for the accuracy of live
              scores, statistics and intermediate results in live betting.
            </span>
          </p>
          <p class="c3">
            <span class="c1">4.20. BET TYPES</span>
          </p>
          <p class="c3">
            <span class="c1">4.20.1. Single Bet</span>
          </p>
          <p class="c3">
            <span class="c1">
              Single bets are the simplest form of betting. You predict an
              outcome, specify the desired stake and place the bet. If your
              prediction proves correct, you win the bet. The winnings are
              calculated by multiplying the odds by the stake.
            </span>
          </p>
          <p class="c3">
            <span class="c1">4.20.2. Multi Bet</span>
          </p>
          <p class="c3">
            <span class="c1">
              If you place bets on two or more games, they are automatically
              displayed as a multi bet. The total odds are calculated by
              multiplying the odds of all the individual games. Please note that
              a multi bet does not pay out anything unless all your predictions
              turn out to be correct.
            </span>
          </p>
          <p class="c3">
            <span class="c1">4.20.3.&nbsp;PM LEAGUE</span>
          </p>
          <p class="c3">
            <span class="c1">
              PM League is an additional opportunity that Amole offers you.
              Besides betting on real matches, now you have a chance to bet on
              alternative events, which are created by Amole and are based on
              real matches and their results.
              <br />
              &nbsp;
              <br />
              Here we have these two real matches:
              <br />
              Manchester City V West Ham United, which starts at 19:00,
              <br />
              Chelsea V Crystal Palace, which starts at 20:00.
              <br />
              Out of these two matches, Amole offers you a Mix match: Manchester
              City V Chelsea the results of which will be clear after two real
              matches end.&nbsp;
              <br />
              And let&rsquo;s say your bet is Match Result - 1 which means
              Manchester City will win.
              <br />
              The first match (Manchester City V West Ham United) ended with the
              score 3:0 and the second one (Chelsea V Crystal Palace) with 2:1.
              So Manchester City scored 3 goals and Chelsea scored 2 goals.
              <br />
              From the results of the matches above, the result of the Mix match
              is Manchester City 3:2 Chelsea.
              <br />
              So your bet wins as Manchester City has won.
              <br />
              &nbsp;
              <br />
              The score of the Mix match will be calculated after the two real
              matches end. You will be able to bet on an alternative match
              regardless of the fact whether you bet on the real ones or not.
              <br />
              You can bet on alternative matches before the real matches start.
              <br />
              You can bet on Mix match with these 8 markets:
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              Match Results (1, X, 2)
              <br />
              Double Chance (1X, 12, X2)
              <br />
              Over/Under
              <br />
              Team Total
              <br />
              Draw no bet
              <br />
              Double Chance/Both Teams To Score
              <br />
              Double Chance/Total Goals
              <br />
              Total Goals/Both Teams To Score
            </span>
          </p>
          <p class="c3">
            <span class="c1">4.20.4.&nbsp;DAILY EXPRESS</span>
          </p>
          <p class="c3">
            <span class="c1">
              Daily Express is a special offer for you, which gives you an
              opportunity to bet on an express type of bet with already selected
              4 events with high possibility to win. Betting on daily express,
              you have an opportunity to get 3500 UNITS besides the money that
              you win.
              <br />
              To get your Daily Express, you need to enter Amole&nbsp;and click
              &ldquo;Daily Express&rdquo;. You can see the ticket ID and the
              bonus amount. Then click the &ldquo;use&rdquo; button at the end
              to submit the bet slip. After just input the bet amount for your
              bet slip to use Daily Express.&nbsp;
              <br />
              Attention. You must place 1000 ETB/ Units or more to participate
              in Daily Express.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              4.20.5.&nbsp;Jackpot
              <br />
              Ticket price &ndash; ETB 100
              <br />
              How does it work?
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              Jackpot is a game, where there is a list of 12 primary and 5
              reserve games from different leagues. You must predict the outcome
              of all 12 primary and 5 reserved games by selecting one of
              offering outcomes 1, x or 2 (Home team will win, draw or away team
              will win). If one of 12 games will be postponed or cancelled,
              first reserve game will substitute the latter, so on up to 5
              games.
            </span>
          </p>
          <p class="c3">
            <span class="c1">How can I win?</span>
          </p>
          <p class="c3">
            <span class="c1">
              You are a Jackpot winner if all 12 games are predicted correctly!
              You can win a big amount in case of 11, 10 or 9 correct
              predictions.
              <br />
              When there are no Jackpot winners (12 correct predictions) the
              payout will be kept and will be added to the next draw. Jackpot
              prize pool is increasing during each draw until someone wins the
              Jackpot.
              <br />
              The winning amount of correct predictions for &nbsp;11, 10 or 9
              games is being determined from draw&rsquo;s sell out (based on
              participants tickets).
              <br />
              When there are more than one winners in any category, the prize
              will be distributed equally among the winners of that category.
            </span>
          </p>
          <p class="c3">
            <span class="c1">How to bet on double combination? (Lines)</span>
          </p>
          <p class="c3">
            <span class="c1">
              A double combination bet means that you can bet on a match by
              choosing two predictions per each match.
              <br />
              To bet with two predictions you can choose 2, 3, etc lines or you
              can just click on the second prediction for the same match.
              <br />
              You can bet with two predictions on up to 7 matches out of 17.
              <br />
              When you bet this way, the number of combinations will increase.
              The number of combinations show how many Jackpot tickets you have.
              It also will increase the bet amount.
              <br />
              &nbsp;
            </span>
          </p>
          <p class="c3">
            <span class="c1">5. Live Betting</span>
          </p>
          <p class="c3">
            <span class="c1">
              5.1. Note that certain &#39;live&#39; feeds - be they on TV, radio
              or the internet - are subject to delays and as such an event may
              be slightly behind or slightly ahead of other users.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              5.2. There will be a &#39;delay&#39; before placing all live bets,
              the length of which varies depending on the sport. The Company
              will not be liable for any errors in the live scores displayed on
              the website.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              5.3. Amole reserves the right to void any bets placed after the
              outcome of an event is known. Should a bet be placed with
              incorrect odds due to delayed &lsquo;Live&rsquo; coverage of an
              event and where a team has gained a significant advantage as
              stated above bets will be voided and will be returned to the user.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              5.4. Odds on all selections change regularly to reflect
              fluctuations in the market or changes in the events themselves. In
              some cases, the odds/handicap may change between the time you put
              your bet on the bet slip and the time you place the bet.
            </span>
          </p>
          <p class="c3">
            <span class="c1">6. SETTLEMENT OF STAKES</span>
          </p>
          <p class="c3">
            <span class="c1">
              6.1. Statistics provided by the official score(s) provider or the
              official website of the relevant competition or fixture will be
              used to settle stakes.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              6.2. Where statistics from an official score(s) provider or
              official website are not available or there is significant
              evidence that the official score(s) provider or official website
              is incorrect, we will use independent evidence to support bet
              settlement.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              6.3. In the absence of consistent, independent evidence or in the
              presence of significant conflicting evidence, bets will be settled
              based on our own statistics.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              6.4 The company takes the result from the official sites (of
              league, championship or team). If there is no official information
              or it is doubtful, the company gives a result after watching the
              broadcast of the match. If for some reason the broadcast is not
              available or there are problems in transmission, then the company
              is guiding by sites that provide results and considers the result
              provided by majority. (e.g according to 4 sites the match ended
              with score 1:1, and there is another site where the score is 3:6
              we consider the result 1:1)
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              6.5 If the information provided by unofficial sources is doubtful,
              the Company waits for the official information. In case if both
              information is lacking all the tickets get returned status, and
              all the bets referring to that event is express tickets are
              calculating with rate 1.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              6.6 If the tickets were calculated according to unofficial results
              and within 24 hours the official result is announced which differs
              from the result given by Company, we recalculate all the tickets
              guiding by official result.
            </span>
          </p>
          <p class="c3">
            <span class="c1">7. OFFERS, BONUSES, PROMOTIONS</span>
          </p>
          <p class="c3">
            <span class="c1">
              7.1. All customer offers are limited to one per Customer, same
              payment account number. We reserve the right to withdraw the
              availability of any offer or all offers to any customer at any
              time and at our sole and absolute discretion. Offers only apply to
              customers who have made an actual/real money deposit with the
              Company.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              7.2. Where any term of the offer or promotion is breached or there
              is any evidence of a series of bets/stakes placed by a customer
              which due to a deposit bonus, enhanced payments, free bets/stakes
              or any other promotional offer results in guaranteed customer
              profits irrespective of the outcome, whether individually or as
              part of a group, the Company reserves the right to reclaim the
              bonus element of such offers and in the Company absolute
              discretion settle bets/stakes at the correct odds, void the free
              bets/stakes or void any bet/stake funded by the deposit bonus. In
              addition, the Company reserves the right to levy an administration
              charge on the customer up to the value of the deposit bonus, free
              bet/stake or additional payment to cover administrative costs. The
              Company further reserves the right to ask any customer to provide
              sufficient documentation for the Company to be satisfied in its
              absolute discretion as to the customer&#39;s identity prior to the
              Company crediting any bonus, free bet/stake or offer to the
              customer&#39;s account.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              7.3. The Company reserves the right to amend the terms of or
              cancel any customer offer at any time.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              8. USE OF THE SERVICE, WEBSITE AND ALL OTHER MEDIA/ELECTRONIC
              PLATFORMS
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              8.1. Information and Content Information accessed by you on the
              Mobile service, Website and all other media/electronic platforms
              (including results, statistics, sporting data and fixture lists,
              odds and betting figures) is for your personal use only and the
              distribution or commercial exploitation of such information is
              strictly prohibited. No warranty is given as to the uninterrupted
              provision of such information, its accuracy or as to the results
              obtained through its use. The information is not intended to
              amount to advice or recommendations and is provided for
              information purposes only. It should not be relied upon when
              placing bets/stakes, which are made at your own risk and
              discretion.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              8.2. Your computer or mobile device and internet connection may
              affect the performance and/or operation of the Mobile service,
              Website and all other media/electronic platforms. The Company does
              not guarantee that the Mobile service, Website and all other
              media/electronic platforms, will operate without faults or errors
              or that the Company services will be provided without
              interruption. The Company does not accept any liability for any
              failures or issues that arise due to your equipment, internet
              connection or internet or telecommunication service provider
              (including, for example, if you are unable to place bets or stakes
              or to view or receive certain information in relation to
              particular events).
            </span>
          </p>
          <p class="c3">
            <span class="c1">9. FAIR USE</span>
          </p>
          <p class="c3">
            <span class="c1">
              9.1. The Mobile service, Website and all other media/electronic
              platforms and the Company products may only be used for the
              purposes of placing bets and stakes on events and/or gaming
              products.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              9.2. You must not use the Mobile service, Website and all other
              media/ electronic platforms for any purpose which (in the
              Company&#39;s opinion) is illegal, defamatory, abusive or obscene,
              or which the Company considers discriminatory, fraudulent,
              dishonest or inappropriate.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              9.3. The Company will seek criminal and contractual sanctions
              against any customer involved in fraudulent, dishonest or criminal
              acts via or in connection with the Mobile service, Website and all
              other media/ electronic platforms or the Company&#39;s products.
              The Company will withhold payment to any customer where any of
              these are suspected. The customer shall indemnify and shall be
              liable to pay to the Company, on demand, all Claims (as defined
              herein above) arising directly or indirectly from the
              customer&#39;s fraudulent, dishonest or criminal act.
            </span>
          </p>
          <p class="c3">
            <span class="c1">10. SOFTWARE AND TECHNOLOGY ISSUES</span>
          </p>
          <p class="c3">
            <span class="c1">
              10.1. You are only permitted to use any and all software made
              available to you via the Mobile service, Website, or other
              media/electronic platforms, for the purpose of using products on
              the Mobile devices or all other media/electronic platforms, and
              save to the extent permitted by applicable law, for no other
              purposes whatsoever.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              10.2. We hereby grant to you a personal, non-exclusive,
              non-transferable right to use the relevant software, for the sole
              purpose of using/playing products on the Mobile devices and all
              other media/electronic platforms, in accordance with the following
              provisions:
            </span>
          </p>
          <p class="c3">
            <span class="c1">10.2.1. You are not permitted to:</span>
          </p>
          <ul class="c12 lst-kix_list_12-0 start">
            <li class="c5 li-bullet-0">
              <span class="c7">
                (i) install or load the software onto a server or other
                networked device or take other steps to make the software
                available via any form of &quot;bulletin board&quot;, online
                service or remote dial-in or network to any other person;
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (ii) sub-license, assign, rent, lease, loan, transfer or copy
                (except as expressly provided elsewhere in these terms and
                conditions) your license to use the software or make or
                distribute copies of the software;
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (iii) enter, access or attempt to enter or access or otherwise
                bypass the Company&#39;s security system or interfere in any way
                (including but not limited to, robots and similar devices) with
                the relevant products or the Mobile service, and all other
                media/electronic platforms any changes to the software and/or
                any features or components thereof; or
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (iv) copy or translate any user documentation provided
                &#39;online&#39; or in electronic format.
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (v) In addition, and except to the minimum extent permitted by
                applicable law in relation to computer programs (including, the
                purposes expressly permitted as per the Kenya Information &amp;
                Communication Act (CAP 411A) of the Laws of Kenya or any law
                replacing/repealing and or amending the said laws and any other
                relevant law) you are not permitted to:
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (vi) translate, reverse engineer, decompile, disassemble,
                modify, create derivative works based on, or otherwise modify
                the software; or
              </span>
            </li>
            <li class="c6 li-bullet-0">
              <span class="c7">
                (vii) reverse engineer, decompile, disassemble, modify, adapt,
                translate, make any attempt to discover the source code of the
                software or to create derivative works based on the whole or on
                any part of the software.
              </span>
            </li>
          </ul>
          <p class="c3">
            <span class="c1">
              10.2.2. You do not own the software. The software is owned and is
              the exclusive property of the Company or a third party software
              provider company (the &quot;Software Provider&quot;). Any software
              and accompanying documentation which have been licensed to the
              Company are proprietary products of the Software Provider and
              protected worldwide by copyright law. Your use of the software
              does not give you ownership of any intellectual property rights in
              the software.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              10.2.3. The software is provided &quot;as is&quot; without any
              warranties, conditions, undertakings or representations, express
              or implied, statutory or otherwise. The Company hereby excludes
              all implied terms, conditions and warranties (including any of
              merchantability, satisfactory quality and fitness for any
              particular purpose). The Company does not warrant that:
            </span>
          </p>
          <ul class="c12 lst-kix_list_13-0 start">
            <li class="c5 li-bullet-0">
              <span class="c7">
                (i) the software will meet your requirements;
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (ii) the software will not infringe any third party&#39;s
                intellectual property rights;
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (iii) the operation of the software will be error free or
                uninterrupted;
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (iv) any defects in the software will be corrected; or
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (v) the software or the servers are virus-free.
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (d) In the event of communications or system errors occurring in
                connection with the settlement of accounts or other features or
                components of the software, neither the Company nor the Software
                Provider will have any liability to you or to any third party in
                respect of such errors. The Company reserves the right in the
                event of such errors to remove all relevant products from the
                Mobile service, Mobile service, Website and all other media/
                electronic platforms, and all other media/electronic platforms,
                and take any other action to correct such errors.
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (e) You hereby acknowledge that your use of the software is
                outside of the Company&#39;s control. Accordingly, you load and
                use the software at your own risk. The Company will not have any
                liability to you or to any third party in respect of your
                receipt of and/or use of the software.
              </span>
            </li>
            <li class="c6 li-bullet-0">
              <span class="c7">
                (f) The software may include confidential information which is
                secret and valuable to the Software Provider and/or the Company.
                You are not entitled to use or disclose that confidential
                information other than strictly in accordance with these Terms
                and Conditions.
              </span>
            </li>
          </ul>
          <p class="c3">
            <span class="c1">
              10.3. While the Company endeavors to ensure that the Mobile
              service, Website and all other media/electronic platforms, are
              available 24 hours a day, the Company shall not be liable if for
              any reason the Mobile service, Website and all other
              media/electronic platforms are unavailable at any time or for any
              period. We reserve the right to make changes or corrections to or
              to alter, suspend or discontinue any aspect of the content or
              services or products available through it, including your access
              to it.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              10.4. You must not misuse the Mobile service, Website and all
              other media/ electronic platforms by introducing viruses, Trojans,
              worms, logic bombs or other material which is malicious or
              technologically harmful. In particular, you must not access
              without authority, interfere with, damage or disrupt the Mobile
              service, Website and all other media/electronic platforms, or any
              part of it; any equipment or network on which the data is stored;
              any software used in connection with the provision of the Mobile
              service, Website and all other media/electronic platforms; or any
              equipment, software, owned or used by a third party. You must not
              attack our Mobile service, Website and all other media/electronic
              platforms, via a denial-of-service attack. We will not be liable
              for any loss or damage caused by a distributed denial-of-service
              attack, viruses or other technologically harmful material that may
              infect your computer equipment, computer programs, data or other
              proprietary material due to your use of software or to your
              downloading of any material posted on it, or on any Mobile
              service, Website and all other media/electronic platforms, linked
              to it.
            </span>
          </p>
          <p class="c3">
            <span class="c1">11. THIRD PARTY CONTENT</span>
          </p>
          <p class="c3">
            <span class="c1">
              11.1. The Company receives feeds, commentaries and content from a
              number of suppliers. Certain third party product providers may
              require you to agree to additional terms and conditions governing
              the use of their feeds, commentaries and content. If you do not
              accept the relevant third party terms and conditions, do not use
              the relevant feeds, commentaries or content.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              11.2. The Company does not accept any liability in respect of any
              third party feeds, commentaries and content.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              11.3. The Company does not allow any employee, anyone else in any
              way connected to such employee or anyone otherwise connected to a
              third party service provider (to be determined in the
              Company&#39;s absolute discretion) to bet/stake on any market or
              event where the third party service provider is providing a
              service to the Company. The Company will void any bet/stake where
              it determines in its absolute discretion that such betting has
              taken place.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              11.4. Where the Mobile service, Website and all other
              media/electronic platforms, contains links to third party
              resources, these links are provided for your information only. The
              Company has no control over the content of these sites or
              resources, and accepts no liability for them or for any loss or
              damage that may arise from your use of them. The inclusion of a
              link to a third party does not constitute an endorsement of that
              third party&#39;s product or services (if applicable).
            </span>
          </p>
          <p class="c3">
            <span class="c1">12. RESPONSIBILITIES</span>
          </p>
          <p class="c3">
            <span class="c1">
              12.1. The Company will not be liable for any errors in respect of
              bets or stakes including where:
            </span>
          </p>
          <ul class="c12 lst-kix_list_14-0 start">
            <li class="c5 li-bullet-0">
              <span class="c7">
                (i) the Company has incorrectly stated the relevant
                odds/spreads/handicap/totals;
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (ii) the Company continues to accept bets or stakes on closed or
                suspended markets;
              </span>
            </li>
            <li class="c2 li-bullet-0">
              <span class="c7">
                (iii) the Company incorrectly calculates or pays a settlement
                amount; or
              </span>
            </li>
            <li class="c6 li-bullet-0">
              <span class="c7">
                (iv) any error occurs in a random number generator or pay tables
                included, incorporated or used in any game or product.
              </span>
            </li>
          </ul>
          <p class="c3" id="h.qmcgpz46eaj9">
            <span class="c1">
              12.2. Incorrect Price - Prior to the start of an event, In-Play or
              after the event, where an Obvious Error is identified any open
              bets will stand and be settled at the Company revised price. Where
              there is sufficient time before the start of an event, the Company
              will endeavor to contact the customer and may in our absolute
              discretion allow the option of cancelling the bet.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              12.3. Where there is sufficient time before the start of an event,
              the Company will endeavor to contact the customer and may in our
              absolute discretion allow the option of cancelling the bet.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              12.4. Incorrect Fixture - Where the wrong player or team is quoted
              within a fixture name all bets will be void. Such determination
              shall be in the Company&#39;s absolute discretion.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              12.5. Wrong Participant - If a wrong participant is quoted for any
              match or event, bets placed on that participant will be void;
              other participants may also be void. Such determination shall be
              in the Company&#39;s absolute discretion.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              12.6. Late Bets - If for any reason a pre-event bet is
              inadvertently accepted after a match or event has commenced, bets
              will be settled as:
            </span>
          </p>
          <ul class="c12 lst-kix_list_15-0 start">
            <li class="c19 li-bullet-0">
              <span class="c7">
                (b) If the event or market is not covered In-Play then the bet
                will stand as long as the selected participant or team has not
                gained a material advantage (e.g. a score, sending off for the
                other team etc.). Where a material advantage has been gained the
                Company reserve the right to void the bet, win or lose. Any bet
                placed where the outcome is already known, including In-Play,
                will be made void.
              </span>
            </li>
          </ul>
          <p class="c3">
            <span class="c1">13. OUR INTELLECTUAL PROPERTY RIGHTS</span>
          </p>
          <p class="c3">
            <span class="c1">
              13.1. The contents of the Mobile service, Website and all other
              media/ electronic platforms, and all other media/electronic
              platforms owned by the company are protected by international
              copyright laws and other intellectual property rights. The owner
              of these rights is the Company, its affiliates or other third
              party licensors.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              13.2. All product and company names and logos mentioned on the
              Mobile service, Website and all other media/electronic platforms
              are the trademarks, service marks or trading names of their
              respective owners, including the Company.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              13.3. Except to the extent required to use a product for the
              purpose of placing bets or stakes, no part of the Website may be
              reproduced or stored, modified, copied, republished, uploaded,
              posted, transmitted or distributed, by any means or in any manner,
              or included in any other website or in any public or private
              electronic retrieval system or service including text, graphics,
              video, messages, code and/or software without our express prior
              written consent.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              13.4. If you make use of a feature that allows you to upload
              material, information, comments, postings or other content to the
              Mobile service, Website and all other media/electronic platforms
              (&quot;User Content&quot;), then the User Content will be
              considered to be non-confidential and non-proprietary and the
              Company has the right to use, copy, distribute and disclose to
              third parties any User Content for any purpose. The Company also
              has the right to disclose your identity to any third party who is
              claiming that any User Content posted or uploaded by you to the
              Mobile service, Website and all other media/electronic platforms,
              constitutes a violation of their intellectual property rights or
              of their right to privacy. The Company has the right to remove,
              amend or edit any User Content you make on the Mobile service,
              Website and all other media/electronic platforms.
            </span>
          </p>
          <p class="c3">
            <span class="c1">
              13.5. Any commercial use or exploitation of the Website or its
              content is strictly prohibited. These Terms and Conditions, the
              Privacy Policy, the Rules and any document expressly referred to
              in them and any guidelines or rules posted on the Website
              constitute the entire agreement and understanding.&nbsp;
            </span>
          </p>
          <p class="c22">
            <span class="c18 c23">Amolebet </span>
          </p>
          <p class="c0">
            <span class="c8"></span>
          </p>
          <p class="c14">
            <span class="c16">Support@amole.bet</span>
          </p>
          <p class="c14">
            <span
              style={{
                overflow: "hidden",
                display: "inline-block",
                margin: "0px",
                border: "0px solid #000000",
                transform: "rotate(0rad) translateZ(0px)",
                WebkitTransform: "rotate(0rad) translateZ(0px)", // camelCase for vendor prefixes
                width: "33px",
                height: "33px",
              }}
            >
              <img
                alt="Tell."
                src="images/image1.png"
                style={{
                  width: "33px",
                  height: "33px",
                  marginLeft: "0px",
                  marginTop: "0px",
                  transform: "rotate(0rad) translateZ(0px)",
                  WebkitTransform: "rotate(0rad) translateZ(0px)",
                }}
                title=""
              />
            </span>
          </p>
          <p class="c14">
            <span class="c25">
              Security
              <br />
            </span>
          </p>
          <p class="c0">
            <span class="c8"></span>
          </p>
          <p class="c13">
            <span class="c17 c18">
              Betting is addictive and can be physiologically harmful
            </span>
          </p>
          <p class="c13">
            <span class="c17 c18">
              Amolebet is licensed and regulated by the National
            </span>
          </p>
          <p class="c13">
            <span class="c17">
              Lottery Administration of Ethiopia, license No.:{" "}
            </span>
            <span class="c27">140/2013</span>
          </p>
          <p class="c11">
            <span class="c10"></span>
          </p>
        </div>
      </div>
    </>
  );
};

const Section = ({ title, items, ordered = false }) => (
  <div className="mb-6">
    {title && <h3 className="text-xl font-semibold mb-2">{title}</h3>}
    {ordered ? (
      <ol className="list-decimal ml-6 text-sm text-white space-y-1">
        {items.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ol>
    ) : (
      <ul className="list-disc ml-6 text-sm text-white space-y-1">
        {items.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
    )}
  </div>
);

export default TermsAndConditions;
